import { Component, input } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { CmsTarget } from '@fcom/core-api';

@Component({
  selector: 'fin-cta-big-link',
  styleUrls: ['./cta-big-link.component.scss'],
  templateUrl: './cta-big-link.component.html',
  standalone: false,
})
export class CtaBigLinkComponent {
  readonly SvgLibraryIcon = SvgLibraryIcon;

  teaserTitle = input<string>();
  target = input<CmsTarget>();
  teaserText = input<string>();
  layout = input<'small' | 'xsmall' | undefined>();
}
